import { ParseNumberToUser } from "../../global";
import { Integer } from "../flowchart/utils/tools";

export var FiltersMixin = {
  name:"FiltersMixin",
  filters:{
    FilterTime: function (value){
      value = value.slice(0,8);
      return value
    },

    ParseNumber: function (num) {
      return ParseNumberToUser(num)
    },

    FilterDate: function (date){        
      if(!date){
        date = new Date();
      }else{
        if(date.toString().includes("/"))
        {
          let dt = date.split("/")
          date = new Date(dt[2],dt[1]-1,dt[0])
        }
        else if(typeof date == "string")
        {
          let dt = date.toString().split(" ")[0]
          date = new Date(dt)
        }
        else if(date._d)
        {
          date = date._d
        }
      }

      let day = date.getDate().toString()
      day = day.length == 1 ? "0" + day : day
      
      let month = (date.getMonth() + 1).toString()
      month = month.length == 1 ? "0" + month : month

      let year = date.getFullYear().toString()

      return `${day}/${month}/${year}`
    }
  },

  methods: {
    MaskDate(date){
      if(!date){
        date = new Date();
      }
      else{
        if(date.toString().includes("/"))
        {
          let dt = date.split("/")
          date = new Date(dt[2],dt[1]-1,dt[0])
        }
        else if(typeof date == "string")
        {
          let dt = date.toString().split(" ")[0]
          date = new Date(dt + " 00:00:00")
        }
        else if(date._d)
        {
          date = date._d
        }
      }

      let day = date.getDate().toString()
      day = day.length == 1 ? "0" + day : day
      
      let month = (date.getMonth() + 1).toString()
      month = month.length == 1 ? "0" + month : month
      
      let year = date.getFullYear().toString()
      
      return `${day}/${month}/${year}`
    },

    MaskTime(value){
      if (value.length > 10)
        value = value.split(" ")[1]
      else if(!value || value.includes("/") || value.includes("-"))
        return "00:00:00";

      value = value.replaceAll(":", "");
      value = value.replaceAll("+", "");
      value = value.replaceAll("-", "");
      value = value.replaceAll("/", "");
      value = value.replaceAll("*", "");


      let hour = "00";
      let minutes = "00";
      let seconds = "00";

      if(value.length > 0){
        hour = value.slice(0,2);
        hour = hour > 23 ? 23 : this.isNumTime(hour);
      }

      if(value.length > 2){
        minutes = value.slice(2,4);
        minutes = minutes > 59 ? 59 : this.isNumTime(minutes);
      }

      if(value.length > 4){
        seconds = value.slice(4,6);
        seconds = seconds > 59 ? 59 : this.isNumTime(seconds);
      }
      
      return `${hour}:${minutes}:${seconds}`
    },

    MaskDateTime(value){
      return `${this.MaskDate(value)} ${this.MaskTime(value)}`
    },

    MaskDateTimeShort(value) {
      return `${this.MaskDate(value)} ${this.MaskTime(value).slice(0, 5)}`;
    },
    


    isNumTime(value){
      if(!isNaN(value)){
        if(value.length == 0)
          return "00";
        if(value.length == 1)
          return "0"+value;

        return value
      }
      return "00";
    },

    

    ParseNumber(num){
      return ParseNumberToUser(num)
    },
    
    ParseInteger(num) {
      return Integer(num);
    },
    
    DiffInDays(start, end){
      if(!start || !end || !start.toString().includes("/") || !end.toString().includes("/")){
        return 0
      }
      let dtStart = start.split("/")
      let dtEnd = end.split("/")
      let startDate = new Date(dtStart[2],dtStart[1]-1,dtStart[0])
      let endDate = new Date(dtEnd[2],dtEnd[1]-1,dtEnd[0], 23, 59, 59)
      let diff = endDate.getTime() - startDate.getTime()

      let late = diff > 0 ? false : true

      if(late){
        startDate = new Date(dtStart[2],dtStart[1]-1,dtStart[0], 23, 59, 59)
        endDate = new Date(dtEnd[2],dtEnd[1]-1,dtEnd[0])
        diff = startDate.getTime() - endDate.getTime()
      }
      
      let days = Math.ceil(diff / (1000 * 60 * 60 * 24))
      days = late ? days * (-1) + 1 : days
      
      return days
    }

  },
};
